import { h } from "preact";
import { useRef, useState } from "preact/hooks";

import Reaction from "../../../../foundation/model/Reaction";
import classname from "../../../../foundation/utils/classname";
import ReactionListLocation from "../ReactionListLocation";

import RemainingReactionsPopover from "./RemainingReactionsPopover";

import styles from "./RemainingReactionsButton.module.css";

interface Props {
    reactions: Reaction[];
    userId: string;
    location: ReactionListLocation;
    readOnly?: boolean;
    disabled?: boolean;
    onSelect(emoji: string): void;
}

export default function RemainingReactionsButton({
    reactions,
    userId,
    location,
    readOnly = false,
    disabled = false,
    onSelect
}: Props) {
    const remainingReactionsButtonRef = useRef<HTMLButtonElement>(null);
    const [isRemainingReactionsPopoverVisible, setIsRemainingReactionsPopoverVisible] = useState(false);

    function handleButtonClick() {
        setIsRemainingReactionsPopoverVisible(true);
    }

    function handleRemainingReactionsPopoverClose() {
        setIsRemainingReactionsPopoverVisible(false);
    }

    return (
        <button
            ref={remainingReactionsButtonRef}
            class={classname(styles.remainingReactionsButton, "caption-2", {
                [styles.active]: isRemainingReactionsPopoverVisible
            })}
            type="button"
            onClick={handleButtonClick}>
            +{reactions.length}
            <RemainingReactionsPopover
                targetButton={remainingReactionsButtonRef}
                reactions={reactions}
                userId={userId}
                location={location}
                readOnly={readOnly}
                disabled={disabled}
                open={isRemainingReactionsPopoverVisible}
                onSelect={onSelect}
                onClose={handleRemainingReactionsPopoverClose}/>
        </button>
    );
}
